import { Component, OnInit, DoCheck, HostListener } from '@angular/core';
import { Location, NgIf } from '@angular/common';
import { Router, ActivatedRoute, RoutesRecognized, NavigationEnd, RouterOutlet } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { environment } from 'src/environments/environment';
import { MatomoTracker } from 'ngx-matomo';
import { filter } from 'rxjs/operators';
import { CommonService } from './_service/common.service';
import { appConfig, baseUrl, intUrl, localUrl } from './app.config';
import { AuthorizationService } from './authorization.service';
import { ViewSupplierServiceService } from './view-supplier-service.service';
import { ConfigService } from './../app/_service/config.service';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { ArcaService } from './_service/arca.service';
import { SupplierService } from './_service/supplier.service';
import { ContactsService } from './_service/contacts.service';
import { BrowserTitleService } from './_service/browser-title.service';

const IDLE_SECONDS = 45 * 60;
const IDLE_TIMEOUT_SECONDS = 5;
const NORELOAD_DELAY_MS = 10 * 60 * 1000;
const CODE_PARAM_OFFSET = 5;
const SECONDS_PER_MINUTE = 60;
const MIN_IPN_LENGTH = 7;
const ALCOR_CODE_LENGTH = 6;
const SITE_CODE_LENGTH = 8;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [NgIf, RouterOutlet],
})
export class AppComponent implements OnInit, DoCheck {
  userIpn: string;
  userRole: string = "";
  title = 'ISA - Supplier Referential';
  routedata: any;
  public CheckTemplate = false;
  Notautorized: any = "";
  userAccess: boolean = false;
  loadingInit: boolean = true;
  importIpnModel: any = '';
  Config: any;
  dataConfig:any;
  roleTypeDesc: any = [];
  supplierId = ''
  functionalCompanyIds = [];
  public customLoadingTemplate2 : any;
  timedOut = false;
  popUp: any = true;
  rolechange: any;
  changedRole: string;
  public constructor(
    private commonService: CommonService, 
    public configService:ConfigService,  
    public viewSupplierApi:ViewSupplierServiceService,
    public authservice:AuthorizationService, 
    public _router:Router,
    private location: Location, 
    private router: Router, 
    private route: ActivatedRoute, 
    private http: HttpClient, 
    private matomoTracker: MatomoTracker,
    private idle: Idle,
    private arcaService:ArcaService,
    private supplierService: SupplierService,
    private contactsservice:ContactsService, 
    private browserTitleService: BrowserTitleService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.registerIcons();
    this.changedRole=localStorage.getItem("userRole")
    this.rolechange =   localStorage.getItem("rolechange")
    console.info("App comp called");
    console.info("matomo ID", environment.matomoId);
    this.dataConfig = this.configService.getConfig();
    console.info('Config:', this.dataConfig);
    this.Config = appConfig;
    this.idle.setIdle(IDLE_SECONDS);
    this.idle.setTimeout(IDLE_TIMEOUT_SECONDS); 
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      this.timedOut = false;
    });
    this.idle.onTimeout.subscribe(() => {
      if(window.location.href != `${baseUrl}/logout` && window.location.href != `${baseUrl}/administration` && !window.location.href.includes('view-supplier')){
      console.info('Screen is Idle for 45 mins and more')
      this.popUp = true
      this.authservice.refreshPopUp = true
      this.timedOut = true;
      let element = document.getElementById('btnForRefrshPopup') as HTMLElement;
      element.click()
      setTimeout(()=>{
        if(this.popUp==true){
          this.noreload()
        }
      },NORELOAD_DELAY_MS)
      }
    });
    this.idle.watch();
    let baseUrl2 = `https:${window.location}`;
    let splits = baseUrl2.split('/');
    this.supplierId = splits[splits.length - 1]
    let MatchURl = baseUrl2.match(/view-supplier/g);
    let compUrl = baseUrl
    console.info('componentUrl', compUrl);
    if (compUrl != intUrl && compUrl != `${intUrl}/`) {
    }
    this.loadingInit = true;
    if (this.userIpn == undefined || this.userIpn == '') {
      let twentyMinutesLater = new Date();
      let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
      this.loadingInit = true;
      if (MatchURl == null) {
        if(baseUrl2.match("auth")){
          let i = window.location.href.indexOf("code")
          let params = window.location.href.substring(i+CODE_PARAM_OFFSET)
        let code=  params.split('&')[0];
    this.authservice.getAuthToken(code).subscribe((userToken)=>{
      if(userToken['res']['error']==null ||userToken['res']['error']==undefined){
  const IDPIdToken = this.authservice.decodejwt(userToken['res']['token']['id_token']);
  console.info("IPD EXPIRES INITAL TIME SETTING");
  let twentyMinutesLater2 = new Date();
  let oktaExpTime = (IDPIdToken['exp'] - IDPIdToken['iat']) / SECONDS_PER_MINUTE;
  let oktathirtyMin = twentyMinutesLater2.setMinutes(twentyMinutesLater2.getMinutes() + oktaExpTime);

  console.info("exp time : ", oktaExpTime);
  console.info('user',userToken)
  localStorage.setItem("IDPAccessToken", userToken['res']['token']['access_token']);
  localStorage.setItem("IDPIdToken", userToken['res']['token']['id_token']);
  localStorage.setItem("IDPexpiredtime", JSON.stringify(oktathirtyMin));
  localStorage.setItem("IDPexpiredMinutes", JSON.stringify(oktaExpTime));
  localStorage.setItem("OKTARefreshToken", userToken['res']['token']['refresh_token']);

  // Check if this is a silent refresh tab - if so, close it after tokens are stored
  if (localStorage.getItem('silentRefreshInProgress') === 'true') {
    console.info('Silent refresh completed, closing tab');
    localStorage.removeItem('silentRefreshInProgress');
    window.close();
    return;
  }

  this.commonService.getUserInformationOkta().then(userVal => {
    this.loadingInit = true;
    this.authservice.getRefreshTokenTimer()
    window.stop();
    console.info('userinfo>>', userVal);
    console.info('authenticated');
    console.info("User Information is ", userVal);
    this.userIpn = userVal['userinfo']['login'];
    commonService.fromApp_UserIPN = userVal['userinfo']['login'];
    commonService.fromApp_UserEmail = userVal['userinfo']['email'];
    commonService.fromApp_UserName = `${userVal['userinfo']['firstName']} ${userVal['userinfo']['lastName']}`;
    console.info("App role", userVal['userinfo']['roles']);
    let url= localStorage.getItem('currentUrl');
    url= url==null || url==undefined || url=='' || url=='null' ?"/sites":url;
    
    this.router.navigateByUrl(url);
    if (!localStorage.getItem('accessToken') || localStorage.getItem('accessToken')==undefined || parseInt(localStorage.getItem('expiredtime')) <= curentmni) {
      let baseUrl1 = baseUrl
      if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/`) {
        baseUrl1 = intUrl;
      }
     let token = localStorage.getItem("IDPAccessToken");
     let httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
      };
      this.commonService.getHappi().subscribe((_dt: any) => {
      this.http.get(`${baseUrl1}/api/access_token`,httpOptions).subscribe((Acc_token: any) => {
        console.info("token --->3", Acc_token);
        let frmTime = Math.round((Acc_token.expires_in) / SECONDS_PER_MINUTE);
        let thirtymin = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + frmTime);
        localStorage.setItem('accessToken', Acc_token.access_token);
        localStorage.setItem("expiredtime", JSON.stringify(thirtymin));
        localStorage.setItem("expiresMin", `TIME ${frmTime}`);
        this.commonService.getGitVarConfig();

        this.loadingInit = false;
        if (MatchURl != null) {
          localStorage.setItem("IDPexpiredtime", JSON.stringify(thirtymin));
          console.info('set as true');
          this.userAccess = true;
          this.loadingInit = false;
          window.stop();
        }       

      if (userVal['userinfo']['roles'] != undefined) {
      this.userRole = userVal['userinfo']['roles'];
      commonService.fromApp_UserRole = this.rolechange == "true"?  userVal['userinfo']['roles'] : this.changedRole;
      if (this.userRole.includes('Supplier') ) {
        this.importCheckIPN();
      }else{
        this.userAccess = true;
      }
    } else if (MatchURl != null) {
      this.redirectToSupplier();
    } else {
      this.loadingInit = false;
      this.Notautorized = "You are not authorized. Please contact admin team (isa@renault.com).";
      this.userRole = "Norole";
      commonService.fromApp_UserRole = "Norole";
    }
      }, _error => {
        this.loadingInit = false;
      window.location.reload();
      });
    },()=>{
      this.loadingInit = false;
      window.location.reload();
    })
    } else {
      this.commonService.getHappi().subscribe((_dt: any) => {
      this.loadingInit = false;
      this.commonService.getGitVarConfig();
      if (MatchURl != null) {
        this.userAccess = true;
        window.stop();
      }            
      console.info("User Information is ", userVal);
      this.userIpn = userVal['userinfo']['login'];
      commonService.fromApp_UserIPN = userVal['userinfo']['login'];
      commonService.fromApp_UserEmail = userVal['userinfo']['email'];
      commonService.fromApp_UserName = `${userVal['userinfo']['firstName']} ${userVal['userinfo']['lastName']}`;
      console.info("App role", userVal['userinfo']['roles']);

      if (userVal['userinfo']['roles'] != undefined) {
      this.userRole = userVal['userinfo']['roles'];
      commonService.fromApp_UserRole =  this.rolechange == "true"?  userVal['userinfo']['roles'] : this.changedRole;
      if (this.userRole.includes('Supplier') ) {
        this.importCheckIPN();
      }else{
        this.userAccess = true;
      }
    } else if (MatchURl != null) {
      this.redirectToSupplier();
    } else {
      this.loadingInit = false;
      this.Notautorized = "You are not authorized. Please contact admin team (isa@renault.com).";
      this.userRole = "Norole";
      commonService.fromApp_UserRole = "Norole";
    }
  })
  }

})
    }else{
      let url= localStorage.getItem('currentUrl');
        url= url==null || url==undefined || url=='' || url=='null' ?"/sites":url;
      this.router.navigateByUrl(url);
    }
    } 
  ),_err=>{
    window.location.reload()
  }
        } else{
        if (localStorage.getItem('loginit')!='true' || ( localStorage.getItem('IDPexpiredtime') == null || localStorage.getItem('IDPexpiredtime') == "null" || parseInt(localStorage.getItem('IDPexpiredtime')) <= curentmni) ){
          if(localStorage.getItem('loginit')!='loggedOut'){
          this.commonService.getUserInformationOkta()
          }else{
            this.loadingInit = false;
            this.userAccess=true
            this.router.navigateByUrl('/logout');

          }
        }else{
    this.commonService.getUserInformationOkta().then(userVal => {
      this.authservice.getRefreshTokenTimer()

          this.loadingInit = true;
          window.stop();
          console.info('userinfo>>', userVal);
          console.info('authenticated');
          console.info("User Information is ", userVal);
          if (userVal && userVal['userinfo'] && userVal['userinfo']['login']) {
            this.userIpn = userVal['userinfo']['login'];
          } 
          commonService.fromApp_UserIPN = userVal['userinfo']['login'];
          commonService.fromApp_UserEmail = userVal['userinfo']['email'];
          commonService.fromApp_UserName = `${userVal['userinfo']['firstName']} ${userVal['userinfo']['lastName']}`;
          console.info("App role", userVal['userinfo']['roles']);

          if (!localStorage.getItem('accessToken') || localStorage.getItem('accessToken')==undefined || parseInt(localStorage.getItem('expiredtime')) <= curentmni) {
            let baseUrl1 = baseUrl
            if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/`) {
              baseUrl1 = intUrl;
            }
            let token = localStorage.getItem("IDPAccessToken");
            let httpOptions = {
               headers: new HttpHeaders({
                 "Content-Type": "application/json",
                 Authorization: `Bearer ${token}`,
               }),
             };
             this.commonService.getHappi().subscribe((_dt: any) => {
            this.http.get(`${baseUrl1}/api/access_token`,httpOptions).subscribe((Acc_token: any) => {
              console.info("token --->3", Acc_token);
              let frmTime = Math.round((Acc_token.expires_in) / SECONDS_PER_MINUTE);
              let thirtymin = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + frmTime);
              localStorage.setItem('accessToken', Acc_token.access_token);
              localStorage.setItem("expiredtime", JSON.stringify(thirtymin));
              localStorage.setItem("expiresMin", `TIME ${frmTime}`);
              this.commonService.getGitVarConfig();

              this.loadingInit = false;
              if (MatchURl != null) {
                localStorage.setItem("IDPexpiredtime", JSON.stringify(thirtymin));
                console.info('set as true');
                this.userAccess = true;
                this.loadingInit = false;
                window.stop();
              }       
  
            if (userVal['userinfo']['roles'] != undefined) {
            this.userRole = userVal['userinfo']['roles'];
            commonService.fromApp_UserRole = this.rolechange == "true"?  userVal['userinfo']['roles'] : this.changedRole;
            if (this.userRole.includes('Supplier') ) {
              this.importCheckIPN();
            }else{
              this.userAccess = true;
            }
          } else if (MatchURl != null) {
            this.redirectToSupplier();
          } else {
            this.loadingInit = false;
            this.Notautorized = "You are not authorized. Please contact admin team (isa@renault.com).";
            this.userRole = "Norole";
            commonService.fromApp_UserRole = "Norole";
          }
            }, _error => {
              this.loadingInit = false;
            window.location.reload();
            });
          })
          } else {
            this.commonService.getHappi().subscribe((_dt: any) => {
            this.loadingInit = false;
            this.commonService.getGitVarConfig();
            if (MatchURl != null) {
              this.userAccess = true;
              window.stop();
            }            
            console.info("User Information is ", userVal);
            this.userIpn = userVal['userinfo']['login'];
            commonService.fromApp_UserIPN = userVal['userinfo']['login'];
            commonService.fromApp_UserEmail = userVal['userinfo']['email'];
            commonService.fromApp_UserName = `${userVal['userinfo']['firstName']} ${userVal['userinfo']['lastName']}`;
            console.info("App role", userVal['userinfo']['roles']);
  
            if (userVal['userinfo']['roles'] != undefined) {
            this.userRole = userVal['userinfo']['roles'];
            commonService.fromApp_UserRole = this.rolechange == "true"?  userVal['userinfo']['roles'] : this.changedRole;
            if (this.userRole.includes('Supplier') ) {
              this.importCheckIPN();
            }else{
              this.userAccess = true
            }
          } else if (MatchURl != null) {
            this.redirectToSupplier();
            console.info('1');
          } else {
            this.loadingInit = false;
            this.Notautorized = "You are not authorized. Please contact admin team (isa@renault.com).";
            this.userRole = "Norole";
            commonService.fromApp_UserRole = "Norole";
          }
        })
          }
     
      })
        }
             }
      }else {
        this.loadingInit = true;
        if (!localStorage.getItem('accessToken') ||  localStorage.getItem('accessToken')==undefined ||  parseInt(localStorage.getItem('expiredtime')) <= curentmni || !localStorage.getItem('IDPexpiredtime') ||  localStorage.getItem('IDPexpiredtime')==undefined || parseInt(localStorage.getItem('IDPexpiredtime')) <= curentmni) {
          let baseUrl1 = baseUrl
          if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/`) {
            baseUrl1 = intUrl;
          }
          let token = localStorage.getItem("accessToken");
          let httpOptions = {
             headers: new HttpHeaders({
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`,
             }),
           };
          
          this.http.get(`${baseUrl1}/api/newTokenEndpoint`,httpOptions).subscribe((Acc_token: any) => {
            console.info("token --->3", Acc_token);
            let frmTime = Math.round((Acc_token.expires_in) / SECONDS_PER_MINUTE);
            let thirtymin = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + frmTime);
            localStorage.setItem('accessToken', Acc_token.access_token);
            localStorage.setItem("expiredtime", JSON.stringify(thirtymin));
            localStorage.setItem("expiresMin", `TIME ${frmTime}`);
            this.commonService.getHappi().subscribe((_dt: any) => {
            this.commonService.getGitVarConfig();
 
            this.loadingInit = false;
            if (MatchURl != null) {
              localStorage.setItem("IDPexpiredtime", JSON.stringify(thirtymin));
              console.info('set as true');
              this.userAccess = true;
              this.loadingInit = false;
              window.stop();
            }
          })
          }, _error => {
            this.loadingInit = false;
          });
        
        } else {
          this.commonService.getHappi().subscribe((_dt: any) => {
          this.loadingInit = false;
          this.commonService.getGitVarConfig();
          if (MatchURl != null) {
            this.userAccess = true;
            window.stop();
          }
        })
        }
        console.info('3');
      }
    }
  }

  refreshPage(): void {
    this.popUp = false
    this.authservice.refreshPopUp = false
    this.authservice.refreshingPage(true)
  }

  noreload(){
    let token=localStorage.getItem('IDPIdToken');
    localStorage.setItem("IDPAccessToken", null);
    localStorage.setItem("IDPIdToken",null);
    localStorage.setItem("IDPexpiredtime", JSON.stringify(0));
    localStorage.setItem("IDPexpiredMinutes", JSON.stringify(0));
    localStorage.setItem("loginit", 'loggedOut');
    this.authservice.logoutSession(token);
  }
  
  redirectToSupplier() {
    console.info('%c Redirect To Specific Supplier Page', 'color:green;font-weight:bold');
    if (this.supplierId != '') {
    }
  }

  ngDoCheck() {
    let baseUrl2 = `https:${window.location}`;
    let MatchURl = baseUrl2.match(/view-supplier/g);

    if (MatchURl == null) {
      if (this.userIpn != "" && this.userIpn != null) {
        this.CheckTemplate = true;
      }
    }
  }

  ngOnInit() {
    // Matomo is configured via APP_INITIALIZER in app.module.ts
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.browserTitleService.updateForUrl(event.urlAfterRedirects);
      });
}

  importCheckIPN() {
    this.commonService.supplierRole = true;
    let Uid = this.commonService.fromApp_UserIPN;
    console.info('Logging in as --SUPPLIER--');
    this.loadingInit = true;
    if(Uid.length > MIN_IPN_LENGTH){
      this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=${Uid.replace('*', '%2A').replace('@', '%40').replace('.', '%2E')}`).subscribe(data => {
        if(data['personAddresses'].length > 0){
        let personsIds = data['personAddresses'][0]['personRowId']
        this.contactsservice.getSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles?personRowId=in(${personsIds})`).subscribe(data => {
          if(data['supplierCompanyRoles'].length > 0){
            console.info('USER',data)
            let companyId
            if (data.supplierCompanyRoles[0]['personSupplierCompany'].href) {
              companyId = data['supplierCompanyRoles'][0]['personSupplierCompany'].href.split("/");
            } else {
              companyId = data['supplierCompanyRoles'][0]['personSupplierCompany'].split(':')
            }
            // this.supplierService.getGroupAssignments(this.Config.ApiSupplierUrl + "group-assignments?apoStatus=ACTIVE&companyId=" + companyId[1]).subscribe((data1: any) => {
              // let groupId =data1['group-assignments'][0]['groupId']
              this.router.navigateByUrl(`/company-details/${companyId[1]}`);
              this.loadingInit = false;
              this.userAccess = true
              this.commonService.noIpnSupplier = true;
            // })
          } else {
            this.loadingInit = false;
            this.userAccess = false;
            this.Notautorized = "You are not authorized. Please contact admin team (isa@renault.com).";
            this.userRole = "Norole";
          }
        })
      }else {
        this.loadingInit = false;
        this.userAccess = false;
        this.Notautorized = "You are not authorized. Please contact admin team (isa@renault.com).";
        this.userRole = "Norole";
      }
    })
    } else {
      this.importIpnModel = Uid;
      this.ImportIPN();
      this.getRoleTypes();
    }
  }

  ImportIPN() {
    if (this.importIpnModel != '' && this.importIpnModel != undefined) {
      let ipnData: any;
      let companyData: any;
      this.loadingInit = true;
      this.functionalCompanyIds = [];
      let allRoles = [];
      this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${this.importIpnModel}')`).subscribe((data: any) => {
        if (data != null) { 
          ipnData = data;
          if (data['PersonTypeDescription'] && data['PersonTypeDescription'].toLowerCase() == 'b2b renault supplier') {
            this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${this.importIpnModel}')/AdministrativeOrganizations`).subscribe((data1: any) => {
              if (data1 != null) {
                let alcor: string;
                let alcorTemp: string;
                data1.forEach(e => {
                  if (e.Type == 'ENTT') {
                    alcorTemp = e.Code;
                    alcor = alcorTemp.slice(-ALCOR_CODE_LENGTH);
                    console.info('search alcor>>', alcor);
                  }
                });
                if (alcor != '') {
                  this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&value=${alcor}`).subscribe(data2 => {
                    if (data2['company-identifiers'].length > 0) {
                      let companyId = data2['company-identifiers'][0]['linkedCompanyId'];
                      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${companyId}`).subscribe(data3 => {
                        if (data3 != null) {
                          companyData = data3;
                          this.arcaService.getgroup(`${this.Config.ApiArcaURL}Group?$filter=(GroupsSetDomain eq 'GCF' or GroupsSetDomain eq 'FRA') and (GroupsSetId eq 'Purchasing Supplier Contacts' or GroupsSetId eq 'GROUPES ADF' or GroupsSetId eq 'GROUPES ADF - V2') and Uid eq '${this.importIpnModel}'`).subscribe((data4: any) => {
                            console.info('data4', data4);
                            if (data4 != null) {
                              try {
                                if (data4['value']) {
                                  data4['value'].forEach(e => {
                                    if (e.Description.toLowerCase().includes('adf')) {
                                      allRoles.push('ADF');
                                    } else if (e.Description.toLowerCase().includes('kam')) {
                                      allRoles.push('KAM');
                                    } else if (e.Description.toLowerCase().includes('sales contact')) {
                                      allRoles.push('SAL');
                                    }
                                  });
                                }
                              } catch (error) {
                                console.info('error', error);
                              }
                            }
                            this.checkForIpnInRfc(ipnData, companyData, ipnData['Uid'], allRoles);
                          }, _error => {
                            this.checkForIpnInRfc(ipnData, companyData, ipnData['Uid'], allRoles);
                          });
                          this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=${companyId}`).subscribe(data4 => {
                            if (data4['group-assignments'].length > 0) {
                              let groupId = data4['group-assignments'][0]['groupId'];
                              this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`).subscribe((data: any) => {
                                if (data && data != null) {
                                  if (data['groupTypeCode'] == 'BOP/NBOP' || data['groupTypeCode'].toLowerCase() == 'external supplier' ) {
                                    this.loadingInit = false;
                                    this.router.navigateByUrl(`/company-details/${companyId}`);
                                    this.userAccess = true
                                  } else {
                                    this.loadingInit = false;
                                    this.userAccess = false;
                                    this.Notautorized = "Your group is not BOP/NBOP group. Please contact isa@renault.com";
                                    this.userRole = "Norole";
                                  }
                                }
                              });
                            }
                          });
                        } else {
                          this.logOutSupplierUser();
                        }
                      });
                    } else {
                      this.logOutSupplierUser();
                    }
                  });
                } else {
                  this.logOutSupplierUser();
                }
              } else {
                this.logOutSupplierUser();
              }
            }, _error => {
              this.logOutSupplierUser();
            });
            this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${this.importIpnModel}')/FunctionalOrganizations`).subscribe((data1: any) => {
              if (data1 != null) {
                let allCompanies = [];
                data1.forEach(ele => {
                  if (ele.Type.toLowerCase() == 'site') { 
                    let alcorTemp = ele.Code;
                    allCompanies.push(`'${(alcorTemp.slice(-SITE_CODE_LENGTH)).slice(0, ALCOR_CODE_LENGTH)}'`);
                  }
                });
                this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&value=in(${allCompanies})`).subscribe(data2 => {
                  if (data2['company-identifiers'].length > 0) {
                    data2['company-identifiers'].forEach(ele => {
                      if (this.functionalCompanyIds.indexOf(ele.linkedCompanyId) == -1) {
                        this.functionalCompanyIds.push(ele.linkedCompanyId);
                      }
                    });
                  }
                });
                console.info('allcompanies', allCompanies);
              }
            });
          } else {
            this.logOutSupplierUser();
          }
        } else { 
          this.logOutSupplierUser();
        }
      }, _error => {
        this.logOutSupplierUser();
      });
    } else {
      this.logOutSupplierUser();
    }
  }

  logOutSupplierUser() {
    this.loadingInit = false;
    this.userAccess = false;
    this.Notautorized = "You are not authorized. Please contact admin team (isa@renault.com).";
    this.userRole = "Norole";
  }

  checkForIpnInRfc(ipnData, companyData, ipn, allRoles) {
    if (ipn != '') {
      let personRowId;
      let allAddressData: any = [];
      let ipnUpdateId;
      this.contactsservice.getUsers(`${this.Config.ApinewContactsUrl}users?loginId=${this.importIpnModel}`).subscribe(data => {
        if (data['users'].length > 0) { 
          personRowId = data['users'][0]['personRowId'];
          ipnUpdateId = data['users'][0]['rowId']; 
          this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=${personRowId}`).subscribe(data2 => {
            if (data2['personAddresses'].length > 0) {
              data2['personAddresses'].forEach(ele => {
                if (ele.addressType.toLowerCase() == 'telephone') {
                  if (allAddressData[ele.addressType] == undefined) {
                    allAddressData[ele.addressType] = [];
                  }
                  allAddressData[ele.addressType].push(ele);
                } else {
                  allAddressData[ele.addressType] = ele;
                }

              });
            }
            this.updatePersonData(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles);
          });
        } else {
          if (ipnData['Mail'] != '') {
            this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=${ipnData['Mail']}`).subscribe(data1 => {
              if (data1['personAddresses'].length > 0) { 
                personRowId = data1['personAddresses'][0]['personRowId'];
                if (ipnData['Uid'] != '') {
                  const datas =
                  {
                    "loginId": ipnData['Uid'],
                    "loginType": "RENAULT_IPN",
                    "personRowId": personRowId
                  };
                  this.contactsservice.createUsers(`${this.Config.ApinewContactsUrl}users`, datas).subscribe(_data => {

                  });
                }
                this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=${data1['personAddresses'][0]['personRowId']}`).subscribe(data2 => {
                  if (data2['personAddresses'].length > 0) {
                    data2['personAddresses'].forEach(ele => {
                      if (ele.addressType.toLowerCase() == 'telephone') {
                        if (allAddressData[ele.addressType] == undefined) {
                          allAddressData[ele.addressType] = [];
                        }
                        allAddressData[ele.addressType].push(ele);
                      } else {
                        allAddressData[ele.addressType] = ele;
                      }

                    });
                  }
                  this.updatePersonData(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles);
                });
              } else { 
                this.createNewContact(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles);
              }
            });
          } else {
            this.logOutSupplierUser();
          }
        }
      });
    }
  }

  updatePersonData(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles) {
    console.info(allAddressData)
    const updateNames =
    {
      personFirstName: ipnData['FirstName'],
      personLastName: ipnData['LastName']
    }
    this.contactsservice.updatePersons(`${this.Config.ApinewContactsUrl}persons/${personRowId}`, updateNames).subscribe(_data => {

    });

    const emailUpdate =
    {
      summary: ipnData['Mail']
    }
    this.contactsservice.updatePersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses/${allAddressData['EMAIL']['rowId']}`, emailUpdate).subscribe(_data1 => {

    });
    let updates: any = [];
    let phoneUpdate1;
    let phoneUpdate2;
    let updatePhone: any = [];

    if (allAddressData['TELEPHONE']) {
      for (let i = 0; i < allAddressData['TELEPHONE'].length; i++) {
        let addsplit = allAddressData['TELEPHONE'][i].summary.split("*");
        if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "f") {
          if (ipnData['Phone']) {
            for (let j = 0; j < ipnData['Phone'].length; j++) {
              updates[j] = ipnData['Phone'][j]
            }
            phoneUpdate1 =
            {
              phoneNumber: updates[0]
            }
            this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`, phoneUpdate1).subscribe(_data1 => {

            });
          } else {
            this.contactsservice.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`).subscribe(_data => {

            });
          }
        }
        if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "p") {
          if (ipnData['MobilePhoneNumber']) {
            for (let j = 0; j < ipnData['MobilePhoneNumber'].length; j++) {
              updatePhone[j] = ipnData['MobilePhoneNumber'][j]
            }
            phoneUpdate2 =
            {
              phoneNumber: updatePhone[0]
            }
            this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`, phoneUpdate2).subscribe(_data1 => {

            });
          } else {
            this.contactsservice.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`).subscribe(_data => {

            });
          }
        }
      }
    }
    const updateIpn = {
      "loginId": ipnData['Uid']
    }
    if (ipnUpdateId != undefined) {
      try {
        this.contactsservice.updateUsers(`${this.Config.ApinewContactsUrl}users/${ipnUpdateId}`, updateIpn).subscribe(_data2 => {
        });
      } catch (error) {
        console.info('error', error);
      }
    }
    this.updateCheckIPNRoles(ipnData, personRowId, ipnUpdateId, companyData, allRoles);
  }

  updateCheckIPNRoles(ipnData, personRowId, ipnUpdateId, companyData, allRoles = [], page = 1, multiRoleUpdate = [], archiveObj = [], subscribeData = []) {
    let allowedRoles = ['adf', 'kam', 'sales contact'];
    console.info('all roles', allRoles);
    if (allRoles.length > 0) {
      this.contactsservice.getPersonRoles(`${this.Config.ApinewContactsUrl}personRoles?personRowId=${personRowId}&_page=${page}`).subscribe(data => {
        if (data['personRoles'].length > 0) {
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            data['personRoles'].forEach(e => {
              subscribeData.push(e);
            });
            this.updateCheckIPNRoles(ipnData, personRowId, ipnUpdateId, companyData, allRoles, page + 1, multiRoleUpdate, archiveObj, subscribeData);
          } else if (data['maxPage'] == page) {
            let anotherRoleExist: any = false;
            subscribeData.forEach(roleObj => {
              let roleRCF = roleObj.roleTypeCode.toLowerCase();
              if (allRoles.indexOf(roleObj.roleTypeCode) == -1) {
                archiveObj.push(roleObj.rowId);
              }
              allRoles.forEach(e => {
                if (roleRCF == e.toLowerCase()) {
                  console.info('same role exist');
                } else {
                  anotherRoleExist = true;
                  multiRoleUpdate.push(e);
                }
              });
            });
            if (anotherRoleExist == true) {
              multiRoleUpdate.forEach(e => {
                console.info('creating new 1', e, personRowId);
                this.createNewRoleContact(personRowId, e, companyData);
              });
            }
            const archiveDate = { endDate: this.commonService.getTodayDate() }
            archiveObj.forEach(_e => {
              this.contactsservice.updatePersonRoles(`${this.Config.ApinewContactsUrl}personRoles/`, archiveDate).subscribe(_data => {

              });
            });
          }
        } else { 
          allRoles.forEach(e => {
            console.info('creating new 3', e, personRowId);
            this.createNewRoleContact(personRowId, e, companyData);
          });
        }
      });
    } else if (allRoles.length == 0) {
      allRoles.push('DCC');
      this.contactsservice.getPersonRoles(`${this.Config.ApinewContactsUrl}personRoles?personRowId=${personRowId}&_page=${page}`).subscribe(data1 => {
        if (data1['personRoles'].length > 0) {
          if (data1['maxPage'] > 1 && data1['maxPage'] != page) {
            data1['personRoles'].forEach(e => {
              subscribeData.push(e);
            });
            this.updateCheckIPNRoles(ipnData, personRowId, ipnUpdateId, companyData, allRoles, page + 1, multiRoleUpdate, archiveObj, subscribeData);
          } else if (data1['maxPage'] == page) {
            let otherRolesExist = false;
            subscribeData.forEach(roleObj => {
              if (roleObj.roleTypeCode.toLowerCase() == 'sal') {
                roleObj.roleTypeCode = 'sales contact';
              }
              console.info(roleObj.roleTypeCode);
              if (allowedRoles.indexOf(roleObj.roleTypeCode.toLowerCase()) != -1) {
                console.info('deleting', roleObj);
                this.contactsservice.deletePersonRoles(`${this.Config.ApinewContactsUrl}personRoles/${roleObj.rowId}`).subscribe(_data2 => {

                });
              } else if (allowedRoles.indexOf(roleObj.roleTypeCode.toLowerCase()) == -1) {
                otherRolesExist = true;
              }
            });
            if (otherRolesExist == false) {
              console.info('creating new 4', 'DCC');
              this.createNewRoleContact(personRowId, 'DCC', companyData);
            }
          }
        } else {
          console.info('creating new 5', 'DCC');
          this.createNewRoleContact(personRowId, 'DCC', companyData);
        }
      });
    }
  }

  createNewRoleContact(personRowId, role, companyData) {
    if (role.toLowerCase() == 'sales contact') {
      role = 'SAL';
    }
    const newCompanyLink =
    {
      personRowId: personRowId,
      startDate: this.commonService.getTodayDate(),
      personSupplierCompany: `CtcSupplierCompanyService:${companyData['rowId']}`,
      personRoleStatus: 'VALIDATED',
      roleTypeCode: role,
      roleTypeId: this.roleTypeDesc[role].rowId
    }
    try {
      this.contactsservice.createSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles`, newCompanyLink).subscribe(_data2 => {

      });
    } catch (error) {
      console.info('error', error);
    }
    if (this.functionalCompanyIds.length > 0) {
      this.functionalCompanyIds.forEach(element => {
        const newCompanyLink =
        {
          personRowId: personRowId,
          startDate: this.commonService.getTodayDate(),
          personSupplierCompany: `CtcSupplierCompanyService:${element}`,
          personRoleStatus: 'VALIDATED',
          roleTypeCode: role,
          roleTypeId: this.roleTypeDesc[role].rowId
        }
        try {
          this.contactsservice.createSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles`, newCompanyLink).subscribe(_data2 => {

          });
        } catch (error) {
          console.info('error', error);
        }
      });
    }
  }

  createNewContact(ipnData, _personRowId, ipnUpdateId, _allAddressData, companyData, allRoles) {
    const createNames =
    {
      personFirstName: ipnData['FirstName'],
      personLastName: ipnData['LastName']
    }
    let updates: any = [];
    let updatePhone: any = [];
    const createEmail =
    {
      email: ipnData['Mail']
    }
    this.contactsservice.createPersons(`${this.Config.ApinewContactsUrl}persons`, createNames).subscribe(data => {
      let personRowIdNew = data['rowId'];
      const newIpnCreate =
      {
        "loginId": ipnData['Uid'],
        "loginType": "RENAULT_IPN",
        "personRowId": personRowIdNew
      }
      this.contactsservice.createUsers(`${this.Config.ApinewContactsUrl}users`, newIpnCreate).subscribe(_data2 => {

      });
      this.contactsservice.createEmailAddress(`${this.Config.ApinewContactsUrl}emailAddresses`, createEmail).subscribe(data => {
        const udpateEmail = {
          "personRowId": personRowIdNew,
          "addressType": "EMAIL",
          "addressIdentifier": data['identifier'],
          "summary": data['email'],
          "addressId": data['rowId']
        }
        this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpateEmail).subscribe(_data1 => {

        });
      });
      if (ipnData['Phone']) {
        for (let i = 0; i < ipnData['Phone'].length; i++) {
          updates[i] = ipnData['Phone'][i];
        }
        const phoneUpdate1 =
        {
          phoneType: 'F',
          phoneNumber: updates[0]
        }
        this.contactsservice.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, phoneUpdate1).subscribe(data => {
          const udpatePhone = {
            "personRowId": personRowIdNew,
            "addressType": "TELEPHONE",
            "addressId": data['rowId']
          }
          this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpatePhone).subscribe(_data1 => {

          });
        });
      }
      if (ipnData['MobilePhoneNumber']) {
        for (let i = 0; i < ipnData['MobilePhoneNumber'].length; i++) {
          updatePhone[i] = ipnData['MobilePhoneNumber'][i]
        }
        const cellPhoneUpdate1 =
        {
          phoneType: 'P',
          phoneNumber: updatePhone[0]
        }
        this.contactsservice.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, cellPhoneUpdate1).subscribe(data => {
          const udpatePhone = {
            "personRowId": personRowIdNew,
            "addressType": "TELEPHONE",
            "addressId": data['rowId']
          }
          this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpatePhone).subscribe(_data1 => {

          });
        });
      }
      this.updateCheckIPNRoles(ipnData, personRowIdNew, ipnUpdateId, companyData, allRoles);
    });
  }

  getRoleTypes(page=1) {
    this.contactsservice.getPersonRoleTypes(`${this.Config.ApinewContactsUrl}personRoleTypes?_page=${page}`).subscribe(data => {
      if (data['personRoleTypes'].length > 0) {
        data['personRoleTypes'].forEach(e => {
          this.roleTypeDesc[e.roleTypeCode] = e;
        });
      }
      if(data['maxPage'] > 1 && data['maxPage'] != page){
        this.getRoleTypes(page+1);
      }
    });
  }

  getItem(item) {
    return localStorage.getItem(item)
  }
  getItemRemove(item) {
    return localStorage.getItem(item)
  }

  private registerIcons(): void {
    this.matIconRegistry.addSvgIcon('add-2', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/add-2.svg'));
    this.matIconRegistry.addSvgIcon('add', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/add.svg'));
    this.matIconRegistry.addSvgIcon('downarrow', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/arrow-down-2.svg'));
    this.matIconRegistry.addSvgIcon('calendercharge', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/calendar-charge.svg'));
    this.matIconRegistry.addSvgIcon('cancel', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/cancel.svg'));
    this.matIconRegistry.addSvgIcon('delete', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/delete.svg'));
    this.matIconRegistry.addSvgIcon('download', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/download.svg'));
    this.matIconRegistry.addSvgIcon('edit', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/edit.svg'));
    this.matIconRegistry.addSvgIcon('P05', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/factory.svg'));
    this.matIconRegistry.addSvgIcon('filedownload', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/file-download.svg'));
    this.matIconRegistry.addSvgIcon('filter-1', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/filter-1.svg'));
    this.matIconRegistry.addSvgIcon('filter-2', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/filter-2.svg'));
    this.matIconRegistry.addSvgIcon('help', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/help.svg'));
    this.matIconRegistry.addSvgIcon('home', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/home.svg'));
    this.matIconRegistry.addSvgIcon('info', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/info.svg'));
    this.matIconRegistry.addSvgIcon('mail', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/mail.svg'));
    this.matIconRegistry.addSvgIcon('P09', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/mechanic.svg'));
    this.matIconRegistry.addSvgIcon('P06', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/money-euro.svg'));
    this.matIconRegistry.addSvgIcon('P13', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/arrow-minimize-full.svg'));
    this.matIconRegistry.addSvgIcon('P14', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/P14.svg'));
    this.matIconRegistry.addSvgIcon('map', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/map.svg'));
    this.matIconRegistry.addSvgIcon('P18', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/office.svg'));
    this.matIconRegistry.addSvgIcon('refresh', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/refresh.svg'));
    this.matIconRegistry.addSvgIcon('search', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/search.svg'));
    this.matIconRegistry.addSvgIcon('P19', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/share.svg'));
    this.matIconRegistry.addSvgIcon('P11', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/shopping-bag.svg'));
    this.matIconRegistry.addSvgIcon('P08', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/speaker-dialog.svg'));
    this.matIconRegistry.addSvgIcon('speechcommeny', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/speech-commeny.svg'));
    this.matIconRegistry.addSvgIcon('speechfeedback', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/speech-feedback.svg'));
    this.matIconRegistry.addSvgIcon('speechforum', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/speech-fourm.svg'));
    this.matIconRegistry.addSvgIcon('speechcomment', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/speechcomment.svg'));
    this.matIconRegistry.addSvgIcon('B2bn', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/welcome.svg'));
    this.matIconRegistry.addSvgIcon('speechquestion', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/speech-question.svg'));
    this.matIconRegistry.addSvgIcon('upload', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/upload.svg'));
    this.matIconRegistry.addSvgIcon('P07', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/sites/icons/van-dump-truck.svg'));
    this.matIconRegistry.addSvgIcon('confirm', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/confirm-2.svg'));
    this.matIconRegistry.addSvgIcon('less', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/less-2.svg'));
    this.matIconRegistry.addSvgIcon('information', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/information-bubble.svg'));
    this.matIconRegistry.addSvgIcon('file-reload', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/file-reload.svg'));
  }
}